<template>
  <div class="tile-kebab-menu">
    <Dropdown v-model="show" menu-right>
      <Btn
        type="link"
        class="dropdown-toggle btn-close-background-only"
        :class="{ 'dropdown-selected': show }"
        v-on:click.stop.prevent
        @click="onKebabClick"
        ><span class="text-sm glyphicon glyphicon-option-vertical"></span
      ></Btn>
      <template #dropdown>
        <slot></slot>
      </template>
    </Dropdown>
  </div>
</template>

<script setup lang="ts">
import { Dropdown, Btn } from "uiv";
import { ref } from "vue";

const show = ref(false);

const emit = defineEmits(["openKebab", "closeKebab"]);

const onKebabClick = () => {
  if (!show.value) {
    emit("openKebab");
  }
};

defineExpose({
  close: () => {
    show.value = false;
  },
});
</script>

<style scoped lang="less">
.tile-kebab-menu {
  position: absolute;
  top: 5px;
  right: 5px;
}

.dropdown-toggle {
  color: #8f8f8f;
  display: block;

  &:hover,
  &:focus {
    color: #404040;
  }
}

.glyphicon {
  right: 3px;
}

.dropdown-selected {
  background-size: 100% 100%;
  text-decoration: none;
}
</style>
<style lang="less">
@import (reference) "../styles/bootstrap/variables.less";

@media (max-width: 365px) {
  .dropdown > .dropdown-menu > li > a {
    white-space: normal;
  }
}
</style>
